import { call, put, takeLatest } from 'redux-saga/effects'
import {
    ValidateAddressRequestUCS,
    ValidateAddressResponseUCS,
    ValidateAddressStatusUCS,
} from '@common/state/location/state'
import { fatalErrorActions } from '@common/state/fatal-error/actions'
import buyServices from '@buy/services'
import { locationActions, LocationActionTypes } from '@common/state/location/actions'
import { locationInitialData } from '@common/data'
import { AxiosResponse } from 'axios'

export function* validateAddressSaga(action: ReturnType<typeof locationActions.validateAddress>) {
    const { values, setSubmitButtonDisabled } = action.payload
    let isAddressValid = true
    const validationMessage = 'Billing Address not found, please enter a valid address'

    const addressObj: ValidateAddressRequestUCS = {
        firstName: values.FirstName,
        lastName: values.LastName,
        email: values.Email,
        addressLine1: values.Street1,
        city: values.City,
        postalCode: values.ZipCode.substr(0, 10),
        state: values.StateCode,
        country: values.CountryCode,
        phoneNumber: values.ContactPhone || '0000000000', // UCS validate address API requires a phone number, but if the user hasn't entered it yet, use a fallback
    }

    try {
        yield put(locationActions.setIsValidatingAddress(true))
        // yield delay(1000)
        setSubmitButtonDisabled(true)
        const validateResponse: AxiosResponse<ValidateAddressResponseUCS> = yield call(
            buyServices.validateAddressUCS,
            addressObj
        )
        // only take action if and only if api response returns 'INVALID' or 'EXPORT_FAILED'
        if (validateResponse && validateResponse.data) {
            switch (validateResponse.data.status) {
                case ValidateAddressStatusUCS.VALID:
                case ValidateAddressStatusUCS.INVALID: // WAE1-1798: Treat INVALID address as if it were VALID
                    setSubmitButtonDisabled(false)
                    yield put(locationActions.setValidAddress(true))
                    yield put(locationActions.setAddressErrors(locationInitialData.addressErrors))
                    break
                case ValidateAddressStatusUCS.VALID_UPDATED:
                    yield put(locationActions.setValidAddress(true))
                    yield put(locationActions.setCorrectedAddress(validateResponse.data.correctedAddress!))
                    yield put(locationActions.setAddressErrors(locationInitialData.addressErrors))
                    break
                case ValidateAddressStatusUCS.EXPORT_FAILED:
                    setSubmitButtonDisabled(false)
                    yield put(locationActions.setValidAddress(false))
                    yield put(locationActions.setCorrectedAddress(locationInitialData.correctedAddress))
                    yield put(locationActions.setAddressErrors(validateResponse.data.errors!))
                    isAddressValid = false
                    break
                default:
                    setSubmitButtonDisabled(false)
                    yield put(locationActions.setValidAddress(true))
                    break
            }
        }
    } catch (e) {
        // fail gracefully if any server issues arise
        setSubmitButtonDisabled(false)
        yield put(locationActions.setValidAddress(false))
        yield put(
            locationActions.setAddressErrors([{ message: validationMessage, friendlyMessage: '', code: '', field: '' }])
        )
        yield put(fatalErrorActions.setFormError(true, { trackErrorMessage: validationMessage }))
        yield put(fatalErrorActions.setFatalError(false, { trackErrorMessage: 'validate address failed' }))
    } finally {
        yield put(locationActions.setIsValidatingAddress(false))
    }

    return isAddressValid
}

function* initializeValidateAddressSaga() {
    yield takeLatest(LocationActionTypes.VALIDATE_ADDRESS, validateAddressSaga)
}

export default initializeValidateAddressSaga
